<li
  *ngIf="Service.arProfile"
  class="list-group-item py-3"
>
  <div class="media align-items-center">
    <ng-template [ngIf]="(editMode$ | async) === false" [ngIfElse]="edit">
      <div class="media-body">
        <p class="small text-muted mb-0">Имя пользователя</p>
        <p>
          <a *ngIf="!usernameExist; else username" (click)="editMode$.next(true)"
             class="text-underline small text-muted pointer">
            Указать
          </a>
          <ng-template #username>
            <span *ngIf="showUserNamePrefix">@</span>{{ Service.arProfile?.username }}&nbsp;
            <i-feather *ngIf="Service.type !== 'fellowdesk'" (click)="editMode$.next(true)" name="edit"
                       class="ml-auto icon-md pointer"></i-feather>
          </ng-template>

        </p>
      </div>
      <i-feather name="user" class="text-muted"></i-feather>
    </ng-template>

    <ng-template #edit>

      <div class="media-body">
        <p class="small text-muted mb-3">Изменение</p>
        <form [formGroup]="Form" nz-form (ngSubmit)="setUsername()">
          <nz-form-item>
            <nz-form-control [nzValidateStatus]="(validateStatus$ | async)" nzHasFeedback
            [nzErrorTip]="(checkError$ | async)"
            >
              <input (ngModelChange)="checkUsername($event)" formControlName="username"
                     nz-input placeholder="Username" [(ngModel)]="Service.arProfile.username"
                     class="edit-profile__name"/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-control>
              <button [nzLoading]="(validateStatus$ | async) === 'validating'"
                      [disabled]="(validateStatus$ | async) !== 'success'"
                      nzBlock nz-button nzType="primary" type="submit">
                Сохранить&nbsp;<i-feather name="save" class="icon-md align-top"></i-feather>
              </button>
            </nz-form-control>
          </nz-form-item>
        </form>
      </div>
    </ng-template>
  </div>
</li>
